import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../../../store/reducers/store';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../../resources/routes-constants';
import LeoTag from '../../../common/LeoTag';

const FundArray: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    if (portfolio === undefined){
        return <></>;
    }
    const goToFund = (id: number) => {
        navigate(AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ITEM_ROUTE.replace(":id", `${id}`))
    }

    return <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>{t('PortfolioDetailsFundName')}</TableCell>
            <TableCell>{t('PortfolioDetailsCapitalCommited')}</TableCell>
            <TableCell>{t('PortfolioDetailsCapitalCalled')}</TableCell>
            <TableCell>{t('PortfolioPageItemTVPI')}</TableCell>
            <TableCell>{t('PortfolioPageItemDPI')}</TableCell>
            <TableCell>{t('PortfolioDetailsSectorTags')}</TableCell>
            <TableCell>{t('PortfolioDetailsPercentOfPortfolio')}</TableCell>
            <TableCell>{t('PortfolioDetailsNetAssetValue')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {portfolio.funds.map((r, i) => <TableRow key={r.id}>
                <TableCell>{i+1}.</TableCell>
                <TableCell onClick={() => goToFund(r.id)} sx={{ cursor: "pointer"}}>{r.name}</TableCell>
                <TableCell>€ {Math.round(portfolio.fundraisingTarget * r.proportion).toLocaleString(i18n.language)}</TableCell>
                <TableCell>€ {r.capitalCalled.toLocaleString(i18n.language)}</TableCell>
                <TableCell>{r.tvpi.toFixed(1)}</TableCell>
                <TableCell>{r.dpi.toFixed(1)}</TableCell>
                <TableCell sx={{ display: "flex", gap: "5px"}}>{r.sectors.slice(0,2).map(t => <LeoTag text={t.name} icon={t.icon} key={`sector-${t.id}`}  />)}</TableCell>{/*renderTag(t)*/}
                <TableCell>{Math.round(r.proportion * 100)}%</TableCell>
                <TableCell>€ {r.netWorthValue.toLocaleString(i18n.language)}</TableCell>
            </TableRow>)}
        </TableBody>
    </Table>
    </TableContainer>
}

export default FundArray;